module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABJElEQVRYR+2WzRXBQBSF37NhmRKogA4oQQtEAVYoASsF+CtBB1KCTsTSgucIOZzIzH1zYk42yfbOufPNzZ0fppI/Lnl+qgCqBKwJyGTdf5aUl6NDXlmRrim4EUDGu4Aacn6ZyIDn4f7bEOmayZPF2QbKbBsRUdcIAXQNhB3gmUL9HhFzOw8iScGiFwZIwvcModqGPiFUAD6TUAP4gnAC8AHhDPADIRTTlVu8GsRp67Od4fnQOE8BADkSU4dELnStNX8BPjovwsC0JZ0BXqt7m+eckkjPgjgBIHOk56WgBkDmSC/0C5A50m1HMkwAmSMd3QeKy+h/hXPuALyOp5uT6aZEK0919B6Qkh8kux7db4HxSTaz65oUYAk1JkXGVABVAqUn8AAGQA8wtRhxfgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/btn_double_arrow_pink.png
// module id = /bj5
// module chunks = 1